import React from 'react';

const Header: React.FC = () => {
  return (
    <div className="app-header" style={{
      textAlign: 'center',
      padding: '2em 0 1em',
    }} >
        <img src="/assets/app-logo.png" alt="" style={{
      height: '24spx'
    }} />
    </div>
  );
};

export default Header;